import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "datepicker";
var attributes = {
    VALUE: 'value',
    MIN: 'min',
    MAX: 'max',
    OPEN: 'open',
    DISABLED: 'disabled',
    POPUP_CLASSES: 'popup-classes',
    MASKED: 'masked',
    MASK_FORMAT: 'mask-format',
    SHOW_MASK_FORMAT: 'show-mask-format',
    USE_CHAR_MASK: 'use-char-mask',
    VALUE_MODE: 'value-mode',
    TOGGLE: 'tcw-datepicker-toggle',
    DIALOG_WIDTH_THRESHOLD: 'dialog-width-threshold',
    ALLOW_INVALID_DATE: 'allow-invalid-date',
    SHOW_TODAY: 'show-today',
    SHOW_CLEAR: 'show-clear',
    DISABLED_DAYS_OF_WEEK: 'disabled-days-of-week'
};
var classes = {
    POPUP: 'tyl-datepicker__popup',
};
var selectors = {
    INPUT: 'input, input[tcw-datepicker-input]',
    TOGGLE: "[" + attributes.TOGGLE + "]"
};
var events = {
    CHANGE: elementName + "-change",
    OPEN: elementName + "-open",
    CLOSE: elementName + "-close",
    INPUT: elementName + "-input"
};
export var DATEPICKER_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    events: events,
    attributes: attributes
};
